import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import Input from "../../components/common/Input";
import { isEmpty } from "../../utils/utils";
import Button from "../../components/common/Button";

// const regexValidationPassword = /[A-Za-z0-9\_\@\.\/\#\&\+\-]{8,50}$/;
const regexValidationPassword = /[A-Za-z0-9_@./#&+-]{8,50}$/;

const ChangePassword = ({ handleCompleteNewPassword }) => {
  const [localPassword, setLocalPassword] = useState("");
  const [localPasswordConfirm, setLocalPasswordConfirm] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [validationOk, setValidationOk] = useState(false);

  useEffect(() => {
    validatePassword();
  }, []);

  const handleChangePassword = (value) => setLocalPassword(value);
  const handleChangePasswordConfirm = (value) => setLocalPasswordConfirm(value);

  const validatePassword = () => {
    let valuesAreEmpty =
      isEmpty(localPassword) || isEmpty(localPasswordConfirm);
    if (valuesAreEmpty) {
      setValidationOk(false);
      setValidationMessage("Debe escribir una contraseña");
    }

    // console.log(
    //   regexValidationPassword.test(localPassword.trim()),
    //   regexValidationPassword.test(localPasswordConfirm.trim())
    // );

    if (localPassword?.trim() !== "" && localPasswordConfirm?.trim() !== "") {
      if (localPassword.trim() !== localPasswordConfirm.trim()) {
        setValidationOk(false);
        setValidationMessage("Las contraseñas no coinciden");
      } else if (
        localPassword.trim().length < 8 ||
        localPasswordConfirm.trim().length < 8
      ) {
        setValidationOk(false);
        setValidationMessage(
          "Las contraseñas deben tener por lo minimo 8 caracteres"
        );
      } else if (
        localPassword.trim().length >= 8 &&
        localPasswordConfirm.trim().length >= 8 &&
        !regexValidationPassword.test(localPassword.trim()) &&
        !regexValidationPassword.test(localPasswordConfirm.trim())
      ) {
        setValidationOk(false);
        setValidationMessage(
          "Las contraseñas no cumplen con el formato esperado"
        );
      } else {
        setValidationOk(true);
        setValidationMessage("Las contraseñas coinciden");
      }
    }
  };

  useEffect(() => {
    validatePassword();
  }, [localPassword, localPasswordConfirm]);

  const handleClick = () => {
    if (validationOk) {
      handleCompleteNewPassword(localPassword);
    }
  };

  return (
    <div className="password-layout">
      <>
        <p className="title-04">Hola!</p>
        <p className="title-07">Es necesario que cambies tu contraseña</p>
        <p className="title-08">
          La nueva contraseña debe tener un tamaño mínimo de 8 caracteres.
          Además debe contener letras mayúsculas, minúsculas, números y
          caracteres especiales.
        </p>
        <Input
          label="Contraseña"
          value={localPassword}
          onChange={(newValue) => handleChangePassword(newValue)}
          minLength={8}
          maxLength={50}
          type="password"
        />
        <Input
          label="Confirmar Contraseña"
          value={localPasswordConfirm}
          onChange={(newValue) => handleChangePasswordConfirm(newValue)}
          minLength={8}
          maxLength={50}
          type="password"
        />
        {validationMessage && (
          <span className={validationOk ? "message-success" : "message-error"}>
            * {validationMessage}
          </span>
        )}
        <Button primary text="Continuar" onClick={handleClick} />
      </>
    </div>
  );
};

ChangePassword.propTypes = {
  handleCompleteNewPassword: PropTypes.func,
};

ChangePassword.defaultProps = {
  handleCompleteNewPassword: null,
};

export default ChangePassword;
